import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface WeatherData {
  start_time: string;
  end_time: string;
  is_daytime: boolean;
  temperature: number;
  temperature_unit: string;
  precipitation_probability: number;
  wind_speed: string;
  wind_direction: string;
  icon: string;
  short_forecast: string;
  detailed_forecast: string;
}

export interface TideData {
  current_tide_cycle: string;
  last_tide_time: string;
  last_tide_v: string;
  next_tide_time: string;
  next_tide_v: string;
  minutes_since_last_tide: string;
  minutes_until_next_tide: string;
  current_water_level: string;
  predictions_data: any;
  water_level_data: any;
}

@Injectable({
  providedIn: 'root'
})
export class WeatherService {

  private findApiUrl = environment.findApiUrl;

  constructor(private http: HttpClient) { }

  getWeather(lat: number, long: number): Observable<WeatherData> {
    return this.http.get<WeatherData>(`${this.findApiUrl}/weather?lat=${lat}&long=${long}`);
  }

  getTides(lat: number, long: number): Observable<TideData> {
    return this.http.get<TideData>(`${this.findApiUrl}/tide?lat=${lat}&long=${long}`);
  }
}
